import React from 'react'

import CSSModules from 'react-css-modules'
import styles from './style.module.scss'

import checkIcon from '../../../../../assets/images/spa/check_icon.svg'
import alertIcon from '../../../../../assets/images/spa/alert_icon.svg'
import { MonthlyWorkReportDetail } from 'javascripts/api/generated'


interface StatusInterface {
  'active': string,
  'waiting_acceptance': string,
  'accepted': string,
  'suspending_acceptance': string,
  'waiting_cancellation_agreement': string,
}

type Status = keyof StatusInterface;



const ClientMonthlyWorkReportDetailHeader: React.FC<{ monthlyWorkReport: MonthlyWorkReportDetail }> = CSSModules<React.FC<{ monthlyWorkReport: MonthlyWorkReportDetail }>>((props) => {

  const formatDate: (dateStr: string) => string = (dateStr) => {

    const yyyy = dateStr.substring(0, 4)
    const mm = parseInt(dateStr.substring(4, 6), 10)

    return `${yyyy}年${mm}月`
  }

  const iconStatus: (status: Status) => string = (icon) => {
    const iconStatuses = {
      'active': alertIcon,
      'waiting_acceptance': checkIcon,
      'accepted': checkIcon,
      'suspending_acceptance': checkIcon,
      'waiting_cancellation_agreement': checkIcon
    }
    return iconStatuses[icon]
  }

  const  displayStatus: (status: Status) => string = (status) => {
    const displayStatuses: StatusInterface  = {
      'active': '稼働中',
      'waiting_acceptance': '提出済み',
      'accepted': '提出済み',
      'suspending_acceptance': '提出済み',
      'waiting_cancellation_agreement': '提出済み'
    }
    return displayStatuses[status]
  }

  const formatMinutes = (workingMinutes: number): string => {
    const workingMinutesRounded = Math.round(workingMinutes)
    const hours = Math.floor(workingMinutesRounded / 60)
    const minutes = workingMinutesRounded % 60
    return `${hours}時間${minutes}分`
  }


  return (
    <>
      <h1 styleName='monthly-work-report-title'>作業報告書
        <span styleName='monthly-work-report-subtitle'>（{formatDate(props.monthlyWorkReport.projectMonthlyTerm.targetMonth)} / {props.monthlyWorkReport.projectMonthlyTerm.project.user.fullName}）</span>
      </h1>
    <table styleName="report-table">
      <tbody>
      <tr>
        <th styleName="table-item">案件名</th>
        <td styleName="table-content">{props.monthlyWorkReport.projectMonthlyTerm.project.title}</td>
      </tr>
      <tr>
        <th styleName="table-item">ステータス</th>
        <td className={`${styles['table-content']} ${props.monthlyWorkReport.status === 'active' ? styles['active'] : styles['submit']}`}>
          <img src={iconStatus(props.monthlyWorkReport.status as Status)} alt="Icon" styleName='bills-icon'/>{displayStatus(props.monthlyWorkReport.status as Status)}
        </td>
      </tr>
      <tr>
        <th styleName="table-item">合計作業時間</th>
        <td styleName="table-content">{formatMinutes(props.monthlyWorkReport.clientSummary.workingMinutes)}</td>
      </tr>
      <tr>
        <th styleName="table-item">精算幅</th>
        <td styleName="table-content">{props.monthlyWorkReport.projectMonthlyTerm.project.memberContract.minimumWorkingHours}時間〜{props.monthlyWorkReport.projectMonthlyTerm.project.memberContract.maximumWorkingHours}時間</td>
      </tr>
      </tbody>
    </table>
      <p styleName="gray-copy-text">※内容に関して気になる点がある場合はお問い合わせください。</p>
    </>
)
}, styles)

export default ClientMonthlyWorkReportDetailHeader
